module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Semibold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Semibold-webfont.ttf
// module id = 363
// module chunks = 0